import { render, staticRenderFns } from "./channel-advisor.vue?vue&type=template&id=3f7e9fc7"
import script from "./channel-advisor.vue?vue&type=script&lang=js"
export * from "./channel-advisor.vue?vue&type=script&lang=js"
import style0 from "./channel-advisor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports